import type { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode } from "react";
import { Link } from "react-router";

type Variant = "primary" | "secondary" | "light";

const variants: Record<Variant, string> = {
  primary: "button-primary",
  secondary: "button-secondary",
  light: "button-light",
};

type CommonProps = {
  children: ReactNode;
  variant?: Variant;
  className?: string;
};

type ButtonProps = CommonProps & ButtonHTMLAttributes<HTMLButtonElement>;
type LinkButtonProps = CommonProps & { to: string };

export function buttonClass(variant: Variant = "primary", className = "") {
  return `button-base ${variants[variant]} ${className}`.trim();
}

export function Button({ children, variant = "primary", className, ...props }: ButtonProps) {
  return (
    <button className={buttonClass(variant, className)} {...props}>
      {children}
    </button>
  );
}

export function ButtonLink({ children, to, variant = "primary", className }: LinkButtonProps) {
  return (
    <Link to={to} className={buttonClass(variant, className)}>
      {children}
    </Link>
  );
}

type ActionLinkProps = CommonProps & AnchorHTMLAttributes<HTMLAnchorElement> & { href: string };

export function ActionLink({
  children,
  href,
  variant = "primary",
  className,
  ...props
}: ActionLinkProps) {
  return (
    <a href={href} className={buttonClass(variant, className)} {...props}>
      {children}
    </a>
  );
}
